import {Box, HStack, Text, Tooltip} from '@chakra-ui/react';
import {ProfilUBItemStatutEnum} from 'api-types/ffconnect';
import {useTranslation} from 'react-i18next';

// Affiche un point coloré selon le statut d'un item UB
export const DisplayStatus: React.FC<{
  status: ProfilUBItemStatutEnum | undefined;
  label?: string;
  size?: number;
  textColor?: string;
  fontSize?: string;
  fontWeight?: string;
}> = ({
  status,
  label,
  size = 5,
  textColor = 'black.text',
  fontSize = 'md',
  fontWeight = '400',
}) => {
  // "gagne" = vert
  // "perdu" = rouge
  // "en-baisse" = jaune
  // "a-gagner" = noir
  const color =
    status === 'gagne'
      ? {bg: 'green.success', borderColor: '#E0EEE5'}
      : status === 'perdu'
        ? {bg: '#D94E28', borderColor: '#F3D7D0'}
        : status === 'en-baisse'
          ? {bg: '#E7CB15', borderColor: '#F5F0CC'}
          : status === 'ras'
            ? {bg: 'gray.light', borderColor: 'gray.white'}
            : {bg: 'gray.dark', borderColor: 'gray.light'};

  const Dot = (
    <Box
      bg={color.bg}
      w={size}
      h={size}
      borderRadius='full'
      borderColor={color.borderColor}
      borderWidth={size}
      flexShrink={0}
    />
  );

  if (label) {
    return (
      <HStack>
        {Dot}
        <Text
          color={textColor}
          fontSize={fontSize}
          fontWeight={fontWeight}
        >
          {label}
        </Text>
      </HStack>
    );
  }

  return Dot;
};

export const DisplayStatusChip: React.FC<{
  status: ProfilUBItemStatutEnum | undefined;
  // Libellé optionnel : si fourni, remplace le libellé de statut par défaut
  label?: string;
  // Contenu de tooltip optionnel affiché au survol du chip (ex : règle métier de l'UB)
  tooltip?: React.ReactNode;
}> = ({status, label, tooltip}) => {
  const {t} = useTranslation();
  const bg_color =
    status === 'gagne'
      ? 'green.success_bg'
      : status === 'perdu'
        ? '#FFEAEB'
        : status === 'en-baisse'
          ? '#F7F3DE'
          : 'white';

  const message =
    label ??
    t(`back_office.prise_de_commande.panier.ub_status.${status ?? 'a-gagner'}`);

  const chip = (
    <HStack
      bg={bg_color}
      borderRadius='8px'
      p='2'
      height='25px'
      spacing={1}
      cursor={tooltip ? 'pointer' : undefined}
    >
      <DisplayStatus
        status={status}
        size={4}
      />
      <Text
        fontSize='xs'
        whiteSpace='nowrap'
        color='gray.dark'
      >
        {message}
      </Text>
    </HStack>
  );

  if (tooltip) {
    return <Tooltip label={tooltip}>{chip}</Tooltip>;
  }
  return chip;
};
